import React, { useState, useRef, useEffect } from 'react';
import { Send, X, User } from 'lucide-react';
import { askFollowUp } from '../services/ai';
import siteLogo from '../assets/branding/hardware-genie-logo.png';
import './ChatSidebar.css';

export default function ChatSidebar({ projectTitle, isOpen, onClose }) {
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: `Hi! I'm Chippo. I've analyzed your project. Ask me anything about components, alternatives, wiring, or how to get started.`,
    },
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const send = async () => {
    if (!input.trim() || loading) return;
    const userMsg = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', content: userMsg }]);
    setLoading(true);
    try {
      const reply = await askFollowUp(messages, userMsg);
      setMessages(prev => [...prev, { role: 'assistant', content: reply }]);
    } catch (e) {
      setMessages(prev => [...prev, { role: 'assistant', content: `Sorry, I ran into an issue: ${e.message}` }]);
    }
    setLoading(false);
  };

  return (
    <div className={`chat-overlay ${isOpen ? 'open' : ''}`} aria-hidden={!isOpen}>
      <button className="chat-backdrop" onClick={onClose} aria-label="Close chat overlay" />
      <div className={`chat-sidebar ${isOpen ? 'open' : ''}`} role="dialog" aria-modal="true" aria-label="Chippo chat panel">
        <div className="chat-header">
          <div className="chat-header-left">
            <div className="chat-avatar">
              <img src={siteLogo} alt="Chippo" className="chat-avatar-img" />
            </div>
            <div>
              <div className="chat-title">Chippo</div>
              <div className="chat-sub mono">Ask about {projectTitle || 'your project'}</div>
            </div>
          </div>
          <button className="chat-close" onClick={onClose} onTouchEnd={onClose} type="button">
            <X size={16} />
          </button>
        </div>

        <div className="chat-messages">
          {messages.map((msg, i) => (
            <div key={i} className={`chat-msg ${msg.role}`}>
              <div className="msg-icon">
                {msg.role === 'assistant'
                  ? <img src={siteLogo} alt="Chippo" className="msg-icon-img" />
                  : <User size={14} />}
              </div>
              <div className="msg-bubble">{msg.content}</div>
            </div>
          ))}
          {loading && (
            <div className="chat-msg assistant">
              <div className="msg-icon"><img src={siteLogo} alt="Chippo" className="msg-icon-img" /></div>
              <div className="msg-bubble typing">
                <span /><span /><span />
              </div>
            </div>
          )}
          <div ref={bottomRef} />
        </div>

        <div className="chat-input-area">
          <input
            className="chat-input"
            placeholder="Ask about components, wiring, alternatives..."
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && send()}
          />
          <button className="chat-send" onClick={send} disabled={!input.trim() || loading}>
            <Send size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}

